<template>
  <div
    class="player-container"
    :class="{ 'your-turn': isPlayersTurn }"
  >
    <div class="player-name-container">
      <div class="online-indicator">
        <div
          v-if="isOnline"
          class="online-dot online"
        ></div>
        <div
          v-else
          class="online-dot offline"
        ></div>
        <template v-if="isOnline">Online</template>
        <template v-if="!isOnline">Offline</template>
      </div>

      <div :class="{ 'your-name': isMe }">
        {{ player.name }}
        <span v-if="isMe">(You)</span>
      </div>
    </div>

    <div class="cards">
      <div
        v-for="stock in stocksSortedByStartingPrice"
        :key="stock.id"
      >
        <stock-card
          :hotel-id="stock.id"
          :visible="isAvailable(stock.id)"
        />
        <div class="stock-count">{{ stockCount(stock.id) }}</div>
      </div>
    </div>

  </div>
</template>

<script>
import { formatCurrency } from "@/currency-filter";
import StockCard from "@/components/StockCard";
import { mapGetters } from 'vuex';
import { createPlayersState } from "@/store/game/schema";
import { NS_GAME_STATE } from "@/store/constants";

export default {
  name: 'PlayerRow',

  props: {
    player: {
      type: Object,
      default: createPlayersState(),
    }
  },

  components: {
    StockCard
  },

  filters:{
    formatCurrency,
  },

  computed: {
    ...mapGetters(NS_GAME_STATE, [
      'stocksSortedByStartingPrice',
      'whosTurn',
      'localPlayer',
      'localPlayerId',
    ]),

    isOnline() {
      return this.player.isOnline;
    },

    isPlayersTurn() {
      return this.whosTurn === this.player.id;
    },

    isMe() {
      return this.localPlayerId === this.player.id;
    },
  },

  methods: {
    stockCount(stockId) {
      const count = this.player.stocks[stockId];
      if (count <= 0) {
        return '';
      }
      return count;
    },

    isAvailable(stockId) {
      return Boolean(this.stockCount(stockId));
    }
  }
}
</script>

<style scoped>
.player-container {
  padding: 5px;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: inset 0px -20px 15px #f5f5f5;
}

.player-container:first-child {
  border-top: 1px solid #e0e0e0;
}

.player-name-container {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  margin-top: 6px;
}

.cards {
  display: flex;
}

.online-indicator {
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  padding: 3px 7px;
  color: #3c3c3c;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  box-shadow: 1px 1px 2px #00000061;
  margin-right: 8px;
}

.online-dot {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  margin-right: 6px;
}

.your-name {
  font-weight: 600;
}

.online {
  background-color: #059805;
  box-shadow: inset 2px 2px 10px #95ff95;
  border: 1px solid #00d400;
}

.offline {
  background-color: #8e8d8d;
  box-shadow: inset 2px 2px 10px #cecece;
  border: 1px solid #989696;
}

.your-turn {
  background-color: #00b5c552;
  box-shadow: inset 0 0 0;
}

.stock-count {
  text-align: center;
  margin-right: 6px;
  font-weight: 600;
}


@media screen and (min-width: 1250px) {
  .player-container {
    padding: 10px;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
